export default {
  slots: {
    identity: {
      label: 'ID-dokument',
      hint: "ID-kort, pas eller opholdstilladelse, forside og bagside. Dine partneres ID'er skal også være her.",
    },
    trade_registration: {
      label: 'Erhvervsregistrering (Gewerbeanmeldung)',
      hint: 'Den erhvervsregistrering, du modtog fra din erhvervsstyrelse.',
    },
    commercial_register_extract: {
      label: 'Udskrift fra handelsregisteret (Handelsregisterauszug)',
      hint: 'En aktuel udskrift fra handelsregisteret, hvis din virksomhed er registreret der.',
    },
    bank_statement: {
      label: 'Kontoudtog (Kontoauszug)',
      hint: 'Et aktuelt udtog fra din erhvervskonto, der viser kontohaver og IBAN.',
    },
    shareholder_list: {
      label: 'Liste over anpartshavere (Gesellschafterliste)',
      hint: 'Den aktuelle liste over anpartshavere.',
      hint_gbr: 'Din samarbejdsaftale (Gesellschaftsvertrag) eller en liste over alle partnere.',
    },
    tax_number: {
      label: 'CVR-nummer eller momsnummer (Steuernummer oder USt-IdNr.)',
      hint: 'Et brev fra skattemyndigheden, der viser dit skattenummer, eller bekræftelsen af dit momsnummer.',
    },
  },
  tags: {
    required: 'Påkrævet',
    optional: 'Valgfrit',
    missing: 'Mangler',
  },
  kinds: {
    passport: 'Pas',
    driver_license: 'Kørekort',
    id_card: 'ID-kort',
    residence_permit: 'Opholdstilladelse',
  },
  holders: {
    owner: 'Ejer',
    partner: 'Partner: {{name}}',
  },
  file: {
    with_back: 'Forside og bagside',
    uploaded_at: 'Uploadet {{date}}',
    expires_at: 'Gyldig til {{date}}',
  },
  errors: {
    load: 'Dokumenterne kunne ikke indlæses.',
  },
  empty: 'Ingen fil endnu',
  buttons: {
    add: 'Tilføj fil',
    replace: 'Udskift',
    remove: 'Fjern',
    retry: 'Prøv igen',
  },
  remove_confirm: {
    title: 'Fjern denne fil?',
    description: 'Brug dette, hvis du har uploadet en fil ved en fejl.',
    ok: 'Fjern',
    cancel: 'Annuller',
  },
  toasts: {
    remove_success: 'Fil fjernet',
    remove_error: 'Filen kunne ikke fjernes. Prøv igen.',
  },
};
